import request from '@/plugin/axios'
// 工具列表
export function indexindex (data) {
  return request({
    url: '/Home/index/lists',
    method: 'post',
    data
  })
}
// 需求收集   /Home/index/addReply
export function addReply (data) {
  return request({
    url: '/Home/index/addReply',
    method: 'post',
    data
  })
}
//  工具详情    /Home/index/getInfo
export function getInfo (data) {
  return request({
    url: '/Home/index/getInfo',
    method: 'get',
    params: data
  })
}
// 工具反馈  /Home/index/addFeedback
export function addFeedback (data) {
  return request({
    url: '/Home/index/addFeedback',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/forout.js